<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h2 class="mb-2">Company Metric</h2>
        <highcharts v-if="metricNumberChart" :options="metricNumberChart"></highcharts>
        <h2 class="mt-10 mb-2">Clients</h2>
        <highcharts v-if="clientChart" :options="clientChart"></highcharts>
        <h2 class="mt-10">Data</h2>
        <v-data-table
          :headers="summaryTable.headers"
          :items="summaryTable.data"
          :hide-default-footer="true"
          disable-pagination
          :disable-sort="true"
          class="mt-10"
          >
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import MetricMixin from '@/components/shared/mixins/MetricMixin'
import { COMPANY_METRIC_HISTORY } from '@/constants/graphql/coach/coaching'

export default {
  name: 'CompanyHistory',
  mixins: [MetricMixin],
  data() { 
    return {
      metricNumberChart: null,
      clientChart: null,
      metricNumberChartData: [],
      //numberActiveClientsChartData: [],
      numberClientsOver50ChartData: [],
      numberClientsNoPicsChartData: [],
      numberClientsNoWorkoutChartData: []
    }
  },
  apollo: {
    companyMetricHistory: {
      query: COMPANY_METRIC_HISTORY,
      variables() {
        return {
          dateFrom: this.$moment().subtract(this.startDays, 'days').format("YYYY-MM-DD"),
        };
      },
      fetchPolicy: 'cache-and-network',
      result(response) {
        if(response.data) {
          this.summaryTable.data = []
          this.metricNumberChartData = []
          //this.numberActiveClientsChartData = []
          this.numberClientsOver50ChartData = []
          this.numberClientsNoPicsChartData = []
          this.numberClientsNoWorkoutChartData = []
        
          let averageNumber = {type: 'Metric'}
          let percentageOnTrack = {type: '% on Track'}
          let numberActiveClients = {type: '# active clients'}
          let numberClientsOver50 = {type: '# clients over 50'}
          let numberClientsNoPics = {type: '# clients no pics'}
          let numberClientsNoWorkout = {type: '# clients no workout'}
          
          response.data.companyMetricHistory.forEach((row) => {
            let metricDate = this.$moment(row.metricDate).format("DD-MM")
            this.metricNumberChartData.push(row.averageNumber)
            //this.numberActiveClientsChartData.push(row.numberActiveClients)
            this.numberClientsOver50ChartData.push(Math.round(row.numberClientsOver50 / row.numberActiveClients * 100))
            this.numberClientsNoPicsChartData.push(Math.round(row.numberClientsNoPics / row.numberActiveClients* 100))
            this.numberClientsNoWorkoutChartData.push(Math.round(row.numberClientsNoWorkout / row.numberActiveClients * 100))

            averageNumber[metricDate] = row.averageNumber
            percentageOnTrack[metricDate] = row.percentageOnTrack
            numberActiveClients[metricDate] = row.numberActiveClients
            numberClientsOver50[metricDate] = row.numberClientsOver50
            numberClientsNoPics[metricDate] = row.numberClientsNoPics
            numberClientsNoWorkout[metricDate] = row.numberClientsNoWorkout
          })

          this.summaryTable.data.push(averageNumber)
          this.summaryTable.data.push(percentageOnTrack)
          this.summaryTable.data.push(numberActiveClients)
          this.summaryTable.data.push(numberClientsOver50)
          this.summaryTable.data.push(numberClientsNoPics)
          this.summaryTable.data.push(numberClientsNoWorkout)

          const commonChartOptions = {
            title: {
              text: ''
            },
            plotOptions: {
              series: {
                pointPlacement: 'on'
              }
            },
            credits: {
              enabled: false
            },
          }

          this.metricNumberChart =  {
            ...commonChartOptions,
            chart: {
              type: 'area'
            },
            yAxis: {
              title: {
                text: 'Metric #'
              },
              plotLines: [
                {
                  color: 'red',
                  width: 1,
                  value: 25
                },
                {
                  color: 'yellow',
                  width: 1,
                  value: 50
                },
                {
                  color: 'green',
                  width: 1,
                  value: 75
                }
              ]
            },
            xAxis: {
              categories: this.shortDates
            },
            series: [
              {
                name: 'Metric #',
                data: this.metricNumberChartData
              },
            ]
          }
          this.clientChart = {
            ...commonChartOptions,
            chart: {
              type: 'line'
            },
            yAxis: {
              title: {
                text: ''
              },
            },
            xAxis: {
              categories: this.shortDates
            },
            series: [
              // {
              //   name: '# active clients',
              //   data: this.numberActiveClientsChartData,
              //   color: 'pink'
              // },
              {
                name: '% clients > 50',
                data: this.numberClientsOver50ChartData,
                color: 'green'
              },
              {
                name: '% clients no pics',
                data: this.numberClientsNoPicsChartData,
                color: 'orange'
              },
              {
                name: '% no workouts',
                data: this.numberClientsNoWorkoutChartData,
                color: 'red'
              },
            ]
          }
        }
      },
    },
  },
}
</script>
